import { render, staticRenderFns } from "./NewsletterForm.vue?vue&type=template&id=2a2f7172&scoped=true&"
var script = {}
import style0 from "./NewsletterForm.vue?vue&type=style&index=0&id=2a2f7172&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2f7172",
  null
  
)

export default component.exports